module.exports = __webpack_public_path__ + "static/media/OlenkaSlide.f5aafd4f.jpg";